import { render, staticRenderFns } from "./WorkerPanel.vue?vue&type=template&id=4042c5ec&scoped=true"
import script from "./WorkerPanel.vue?vue&type=script&lang=js"
export * from "./WorkerPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkerPanel.vue?vue&type=style&index=0&id=4042c5ec&prod&lang=scss&scoped=true"
import style1 from "./WorkerPanel.vue?vue&type=style&index=1&id=4042c5ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4042c5ec",
  null
  
)

export default component.exports